import React, { useEffect, useState } from "react";
import CookiesSettings from "./CookiesSettings";
import styles from "./CookiesBanner.module.scss";

const defaultAcceptedCookies = {
  essentialCookies: true,
  marketingCookies: false,
  analyticsCookies: false,
};

export const shouldShowBanner = ({
  essentialCookies,
  marketingCookies,
  analyticsCookies,
}) => {
  return !essentialCookies && !marketingCookies && !analyticsCookies;
};

const CookiesBanner = () => {
  const [acceptedCookies, setAcceptedCookies] = useState(
    defaultAcceptedCookies,
  );
  const [shouldShowSettings, setShouldShowSettings] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const fetchSelectedCookies = async () => {
      const response = await fetch("/accepted-cookies");
      const acceptedCookiesResponse = await response.json();
      setAcceptedCookies(acceptedCookiesResponse);
      setIsVisible(shouldShowBanner(acceptedCookiesResponse));
    };

    fetchSelectedCookies();
  }, []);

  const saveCookieSelection = selection => {
    setShouldShowSettings(false);
    setIsVisible(false);
    const transmitSelection = async selectedCookies => {
      await fetch("/accept-cookies", {
        method: "PUT",
        body: JSON.stringify({ selectedCookies }),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
    };
    transmitSelection(selection);
  };

  const acceptAllCookies = () => {
    saveCookieSelection({
      ...defaultAcceptedCookies,
      marketingCookies: true,
      analyticsCookies: true,
    });
  };

  const rejectCookies = e => {
    e.preventDefault();
    saveCookieSelection(defaultAcceptedCookies);
  };

  const showSettings = e => {
    e.preventDefault();
    setShouldShowSettings(true);
    setIsVisible(false);
  };

  return (
    <>
      <div
        id={styles.cookiesConsent}
        className={`${isVisible ? "" : "hidden"}`}
      >
        <span className={styles.consentText}>
          Auch EDEKA StartHub kommt nicht ohne Cookies aus, um die notwendige
          Seitenfunktionalität und -qualität zu gewährleisten. Mit einem Klick
          auf „Zustimmen“ akzeptierst Du die entsprechende Erfassung und
          Weitergabe Deiner Daten (auch an Drittanbieter). Die Daten werden für
          Analyse, Retargeting und zur Ausspielung von personalisierten Inhalten
          und Werbung auf EDEKA StartHub, sowie auf Drittanbieterseiten genutzt.
          Weitere Informationen findest Du in den{" "}
          <a href="/privacy">Datenschutzhinweisen</a>. Du kannst die Verwendung
          von Cookies&nbsp;
          <a href="#" className="reject" onClick={e => rejectCookies(e)}>
            ablehnen
          </a>
          &nbsp;oder jederzeit über Deine{" "}
          <a href="#" onClick={e => showSettings(e)}>
            Einstellungen anpassen
          </a>
          .
        </span>
        <div className={styles.consentAcceptor}>
          <button
            className={`btn ${styles.changeSettings}`}
            onClick={e => showSettings(e)}
          >
            Einstellungen ändern
          </button>
          <button
            id="accept-btn"
            className={`btn btn-info ${styles.acceptCookies}`}
            onClick={acceptAllCookies}
          >
            Zustimmen
          </button>
        </div>
      </div>
      <CookiesSettings
        selectedCookies={acceptedCookies}
        isVisible={shouldShowSettings}
        saveCookieSelection={saveCookieSelection}
      />
    </>
  );
};

export default CookiesBanner;
